/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditCommentFormContainer_story = {
    readonly id: string;
    readonly " $refType": "EditCommentFormContainer_story";
};
export type EditCommentFormContainer_story$data = EditCommentFormContainer_story;
export type EditCommentFormContainer_story$key = {
    readonly " $data"?: EditCommentFormContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"EditCommentFormContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditCommentFormContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '0ef91a25d0781bbd7aabe58d848c7822';
export default node;
